/**
 * Employees — new (Payroll Increment 1).
 *
 * Sectioned create form (Identity · Compensation · Bank · App access).
 * PII is plaintext on the wire; the domain wraps it.
 *
 * @see prototype/payroll/employee-edit.html
 */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { trpc } from "../../../../lib/trpc.ts";
import { EMPTY_FORM, EmployeeForm, valuesToCreatePayload } from "../../../../features/employees/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/payroll/employees/new")({
  component: NewEmployeePage,
});

function NewEmployeePage() {
  const navigate = useNavigate();
  const utils = trpc.useUtils();
  const create = trpc.employees.create.useMutation({
    onSuccess: async () => {
      await Promise.all([utils.employees.list.invalidate(), utils.employees.counts.invalidate()]);
    },
  });

  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Payroll", to: "/payroll/employees" },
        { label: "Employees", to: "/payroll/employees" },
        { label: "New" },
      ]}
      contentClassName="max-w-none h-full"
      viewportClassName="p-0"
      disableViewportScroll
    >
      <EmployeeForm
        defaultValues={EMPTY_FORM}
        submitLabel="Save employee"
        pendingLabel="Saving…"
        pending={create.isPending}
        serverError={create.error?.message ?? null}
        mode="create"
        backHref="/payroll/employees"
        onSubmit={async (values) => {
          const payload = valuesToCreatePayload(values);
          const result = await create.mutateAsync(payload);
          void navigate({ to: "/payroll/employees/$employeeId", params: { employeeId: result.id } });
        }}
      />
    </WorkspaceShell>
  );
}
